import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/AuthContext';
import { useQueryClient } from 'react-query';

const SignOut = () => {
  const { logout } = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    // Cleanup ChatBot widget BEFORE logout
    try {
      // 1. Call SDK destroy if available
      if (window.ChatBotWidget?.destroy) {
        window.ChatBotWidget.destroy();
      }

      // 2. Remove ALL shadow DOM hosts
      const shadowHosts = document.querySelectorAll(
        '[id^="chatbot-widget-"], [class*="chatbot"], [data-bot-id]'
      );
      shadowHosts.forEach((host) => {
        try {
          host.remove();
        } catch (e) {
          console.error('Error removing ChatBot host:', e);
        }
      });

      // 3. Remove chatbot script tags
      const scripts = Array.from(document.querySelectorAll('script'));
      scripts.forEach((script) => {
        if (script.src && script.src.includes('chatbot')) {
          try {
            script.remove();
          } catch (e) {
            console.error('Error removing ChatBot script:', e);
          }
        }
      });

      // 4. Reset all window references
      window.ChatBotEmbedLoaded = false;
      window.ChatBotEmbed = undefined;
      window.ChatBotWidget = undefined;

      console.log('[ChatBot Widget] Cleaned up on sign out');
    } catch (error) {
      console.error('[ChatBot Widget] Cleanup error during sign out:', error);
    }

    // Then proceed with logout
    logout();
    queryClient.clear();
    navigate('/');
  }, [logout, navigate, queryClient]);

  return <div>SignOut</div>;
};

export default SignOut;
